import React from 'react';
import { getPlatformRegion } from '../../utils/app.utils';
import { languages } from '../../i18n/i18n.language-config';

const defaultElementProps = {
  id: 'recaptcha',
  className: 'g-recaptcha',
  'data-size': 'invisible',
};

// reCAPTCHA site keys for different environments
const RECAPTCHA_SITE_KEYS = {
  [languages['en-AU']]: '6Le3-6wrAAAAANfkMS1znm8ayhae6PNAq6q4eBsg', // Australia
  [languages['en-US']]: '6LeDSOEUAAAAAFLN2ez_AG2WweicCt4MIcQ2Z3JQ', // US (default)
  [languages['en-GB']]: '6LeDSOEUAAAAAFLN2ez_AG2WweicCt4MIcQ2Z3JQ', // UK
};

export const useRecaptcha = (
  widgetId = 'recaptcha',
  elementProps = defaultElementProps
) => {
  const [state, setState] = React.useState({
    token: null,
    error: null,
    exception: null,
  });

  function executeChallenge() {
    try {
      // @ts-expect-error TS(2339): Property 'grecaptcha' does not exist on type 'Wind... Remove this comment to see the full error message
      window.grecaptcha.execute();
    } catch (error) {
      setState((current) => ({
        ...current,
        error: 'Please refresh the page.',
        token: null,
        exception: error,
      }));
    }
  }

  function getToken(token: any) {
    setState((current) => ({
      ...current,
      error: null,
      exception: null,
      token,
    }));
  }

  function resetToken() {
    try {
      // @ts-expect-error TS(2339): Property 'grecaptcha' does not exist on type 'Wind... Remove this comment to see the full error message
      window.grecaptcha.reset();
    } catch (error) {
      setState((current) => ({
        ...current,
        error: 'Please refresh the page.',
        token: null,
        exception: error,
      }));
    }
  }

  function setError(token: any) {
    setState((current) => ({
      ...current,
      error: 'Not able to load captcha at this time',
      token,
    }));
  }

  React.useEffect(() => {
    try {
      // Get the current platform region to determine which site key to use
      const currentRegion = getPlatformRegion();
      const siteKey =
        RECAPTCHA_SITE_KEYS[currentRegion] ||
        RECAPTCHA_SITE_KEYS[languages['en-US']];

      // @ts-expect-error TS(2339): Property 'grecaptcha' does not exist on type 'Wind... Remove this comment to see the full error message
      window.grecaptcha.render(widgetId, {
        sitekey: siteKey,
        callback: getToken,
        'expired-callback': resetToken,
        'error-callback': setError,
      });
    } catch (error) {
      setState((current) => ({
        ...current,
        error:
          'Unable to verify if you are a human or a robot. Please make sure you are on latest version of Chrome or try again after page refresh',
        token: null,
        exception: error,
      }));
    }
  }, [widgetId]);

  return {
    token: state.token,
    recaptchaError: state.error,
    exception: state.exception,
    executeChallenge,
    resetToken,
    getElementProps: () => elementProps,
  };
};
